import cls from "./GameMobileTabs.module.scss";

const TABS = [
  { key: "play", label: "Play" },
  { key: "players", label: "Players" },
  { key: "inbox", label: "Inbox" },
  { key: "stats", label: "Stats" },
  { key: "history", label: "History" },
];

export default function GameMobileTabs({ activeTab, onChange }) {
  return (
    <div className={cls.tabDock}>
      {TABS.map((tab) => (
        <button
          key={tab.key}
          type="button"
          onClick={() => onChange?.(tab.key)}
          className={`${cls.tabButton} ${activeTab === tab.key ? cls.tabButtonActive : ""}`}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
}